'use strict';

import {
  FETCH_MODULE_LIST,
} from '../actions/hardwareDev';

const defVal = {
  pIdDetail: {},
  hardwareData: {},
  moduleList: [],
  requestStatus: 'noRequest',
};

export default (state = defVal, action) => {
  switch (action.type) {
    case FETCH_MODULE_LIST:
      return Object.assign({}, state, {
        moduleList: action.moduleList,
      });
    default:
      return state;
  }
};
